@if (forecast()) {
  <app-control-page-card>

    <app-control-page-card-header>
      <app-control-page-card-icon name="forecast"></app-control-page-card-icon>
      <app-control-page-card-label>{{ 'station-app.__DASHBOARD_TITLE_FORECAST' | AsyncLang | async }}</app-control-page-card-label>
      <app-control-page-card-expand></app-control-page-card-expand>
    </app-control-page-card-header>

    <app-control-page-card-expanded class="is-flex is-column gap-16">
      <app-cp-forecast-today></app-cp-forecast-today>
      <app-cp-forecast-tabs></app-cp-forecast-tabs>
    </app-control-page-card-expanded>

    <app-control-page-card-retracted>
      <app-cp-forecast-tab-week></app-cp-forecast-tab-week>
    </app-control-page-card-retracted>

  </app-control-page-card>
}
